import { type QueryParamConfig, decodeString, encodeString } from "serialize-query-params";

export const STARRED_VIEW_FILTER = "starred";

export type ViewFilter = undefined | typeof STARRED_VIEW_FILTER;

export const viewFilterParam = {
	encode: (viewFilter) => encodeString(viewFilter),

	decode: (string) => {
		if (decodeString(string) === STARRED_VIEW_FILTER) {
			return STARRED_VIEW_FILTER;
		}

		return undefined;
	},
} satisfies QueryParamConfig<undefined | ViewFilter>;
